import React, { ReactElement } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'

export type ScrollbarOptions = {
  suppressScrollY?: boolean
  suppressScrollX?: boolean
}

// eslint-disable-next-line import/prefer-default-export
export const withScroller = (
  content: ReactElement,
  options?: ScrollbarOptions
) => {
  return process.env.NODE_ENV !== 'test' ? (
    <PerfectScrollbar options={{ suppressScrollY: options?.suppressScrollY }}>
      {content}
    </PerfectScrollbar>
  ) : (
    content
  )
}
